export const BRIEF_ELEMENT_ID = 'brief'
